exports = module.exports = require("../../../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n.loading {\n    -webkit-animation-name:             rotate; \n    -webkit-animation-duration:         0.5s; \n    -webkit-animation-iteration-count:  infinite;\n    -webkit-animation-timing-function:  linear;\n}", ""]);

// exports
